import { render, staticRenderFns } from "./DataVisualization.vue?vue&type=template&id=27ecfcb1&scoped=true"
import script from "./DataVisualization.vue?vue&type=script&lang=js"
export * from "./DataVisualization.vue?vue&type=script&lang=js"
import style0 from "./DataVisualization.vue?vue&type=style&index=0&id=27ecfcb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ecfcb1",
  null
  
)

export default component.exports